import { array, bool, func, number } from 'prop-types'
import { memo } from 'react'
import BodyRow from './BodyRow'

const TableBodyRow = memo(
   ({
      data,
      headers,
      onClickRow,
      index: rowIndex = 0,
      withPadding = true,
      stickyColumnCount = 0,
      stickyOffsets = [],
   }) => (
      <tr>
         {headers.map((header, index) => {
            const isSticky = index < stickyColumnCount
            return (
               <BodyRow
                  data={data}
                  header={header}
                  index={index}
                  key={index}
                  onClickRow={onClickRow}
                  rowIndex={rowIndex}
                  withPadding={withPadding}
                  isSticky={isSticky}
                  isLastSticky={index === stickyColumnCount - 1}
                  stickyLeft={isSticky ? stickyOffsets[index] ?? 0 : undefined}
               />
            )
         })}
      </tr>
   ),
)

TableBodyRow.propTypes = {
   data: array,
   headers: array,
   index: number,
   onClickRow: func,
   stickyColumnCount: number,
   stickyOffsets: array,
   withPadding: bool,
}

export default TableBodyRow